/* eslint-disable react/prop-types */
import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

/**
 * Reusable date-time picker — always displays as DD/MM/YYYY hh:mm A.
 * value    : "YYYY-MM-DD HH:mm" string or null
 * onChange : called with "YYYY-MM-DD HH:mm" string or null
 */
export default function MDDateTimePicker({ value, onChange, label, disabled, size = 'small', sx = {} }) {
  const dayjsVal = value ? dayjs(value, 'YYYY-MM-DD HH:mm') : null;

  const handleChange = (newVal) => {
    if (!newVal || !newVal.isValid()) { onChange(null); return; }
    onChange(newVal.format('YYYY-MM-DD HH:mm'));
  };

  return (
    <DateTimePicker
      value={dayjsVal}
      onChange={handleChange}
      disabled={disabled}
      ampm
      inputFormat="DD/MM/YYYY hh:mm A"
      mask="__/__/____ __:__ _M"
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { height: size === 'small' ? 34 : 44, fontSize: '0.82rem' }, ...sx }}
        />
      )}
    />
  );
}
